export default __webpack_public_path__ + "static/media/81t.9a270cdf.jpg";